import React, { lazy, Suspense } from 'react';
import { NavLink } from "react-router-dom";
import '../styles/howTo.css';
import Nav from "../components/nav";
import SEO from '../components/SEO';
import { baseUrl } from '../config';

const LazyBackgroundImage = lazy(() => import('../components/LazyBackgroundImage'));



export default function HowTo() {
    return (
        <div id="howTo">
            <SEO
              title="How to Use ProducerBuddy"
              description="Step-by-step guides for using ProducerBuddy's film production tools. Learn how to script, budget, cast, track, and distribute your film project."
              url="https://producerbuddy.pilomation.com/howTo"
            />
            <Nav />
            <Suspense fallback={<div>Loading...</div>}>
                <LazyBackgroundImage src={require('../assets/img/UiBg.gif')} alt="Background" style={{ width: '100%', height: 'auto' }}>
                    <div id="howToWrapper">
                        <div id="howToContainer">
                            <NavLink to='/pre-production' className="glass-buttone">Pre-Production</NavLink>
                            <NavLink className="glass-buttone">Production</NavLink>
                            <NavLink className="glass-buttone">Post-Production</NavLink>
                        </div>
                    </div>
                </LazyBackgroundImage>
            </Suspense>
        </div>
    );
}
